'use strict';
var AccountActionsMenuController = /** @class */ (function () {
    /*@ngInject*/
    function AccountActionsMenuController(Auth, $state, $scope, $location) {
        var _this = this;
        //$scope.active = true;
        // set the default amount of items being displayed
        this.limit = 10;
        this.currentState = null;
        this.accountFinishedLoading = false;
        this.accountOptions = [
            {
                title: 'Change Primary Account Info',
                state: 'accountInfo'
            },
            {
                title: 'Manage Credit Cards',
                state: 'manageCreditCards'
            },
            {
                title: 'View Brand Agreements',
                state: 'viewBrandAgreements'
            },
            {
                title: 'Manage Certifications',
                state: 'manageCertifications'
            },
            {
                title: 'Manage Shipping Addresses',
                state: 'manageShippingAddresses'
            },
            {
                title: 'Change Email Preferences',
                state: 'changeEmailPreferences'
            },
            {
                title: 'Manage Rx Credentials',
                state: 'manageRx'
            }
        ];
        this.accountListVisible = false;
        this.isAccountPlaceholder = true;
        this.accountPlaceholder = "";
        this.accountShow = function () {
            this.accountListVisible = true;
        };
        var self = this;
        this.uiRouterState = $state.current.name;
        Auth.subscribe($scope, function (event, user) {
            if (user) {
                self.loggedInUser = user;
                if (self.loggedInUser.accountType != 'Practitioner') {
                    _this.accountOptions = [
                        {
                            title: 'Change Primary Account Info',
                            state: 'accountInfo'
                        },
                        {
                            title: 'Manage Credit Cards',
                            state: 'manageCreditCards'
                        },
                        {
                            title: 'Manage Shipping Addresses',
                            state: 'manageShippingAddresses'
                        }
                    ];
                }
                for (var accounts in _this.accountOptions) {
                    if (_this.accountOptions[accounts]['state'] == $state.current.name) {
                        _this.currentState = _this.accountOptions[accounts]['title'];
                    }
                }
                _this.accountPlaceholder = _this.currentState;
                if ($state.current.name == "manageShippingAddressesDropShip") {
                    _this.accountPlaceholder = 'Manage Shipping Addresses';
                }
                _this.selectAccountPage = function (item) {
                    this.accountListVisible = false;
                    $state.go(item.state);
                };
            }
            self.accountFinishedLoading = true;
        }, true);
    }
    return AccountActionsMenuController;
}());
export default AccountActionsMenuController;
//# sourceMappingURL=account-actions-menu.controller.js.map